var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"flag",staticStyle:{"background-image":"url(/SE.png)"},attrs:{"alt":"SE"}}),_vm._v("SE ")])}]

export { render, staticRenderFns }